module.exports = __webpack_public_path__ + "static/media/EV-logo-thumbnail.73a651e9.svg";